export const styles = {
  global: {
    body: {
      color: `secondary.mid-grey`,
      background: `white`
    }
  }
};
